export default "/images/vendor/flag-icon-css/flags/4x3/bv.svg?3d8e6f49fad8459575e1ffe4580f7ada";